import CampaignTable from 'components/tables/campaign/CampaignTable'
import React from 'react'

const index = () => {
    return (
        <CampaignTable />
    )
}

export default index